import { createContext, useContext } from 'react';
import { useTabPane } from './tabPane';

/**
 * Bir pencerenin (Dialog) içinde miyiz? Dialog içeriğine sağlar.
 *
 * Meşgul göstergesi sekmeye bağlı açıldığında sekme kabının içinde (z-40) çiziliyor; pencere
 * ise üst katmanda (z-50). Popup ızgaradan (sonuç penceresi, lookup kütüphanesi) silerken
 * gösterge popup'ın ARKASINDA kalıyordu.
 */
export const InDialogContext = createContext(false);

/**
 * Meşgul göstergesinin kapsamı: pencere içindeyse null (uygulama katmanı, pencerenin üstünde),
 * değilse içinde bulunulan sekme (yalnız o sekme örtülür), sekme de yoksa null.
 */
export function useBusyScope(): string | null {
  const inDialog = useContext(InDialogContext);
  const tabId = useTabPane()?.tabId ?? null;
  return inDialog ? null : tabId;
}
